import React from 'react';
import {PatientsTabKeys} from '@shared/constants/Mapping';
import './PatientDetailsContainer.scss';
import DetailsContainer from '../../Containers/DetailsContainer';
import MessagesContainer from '../../Containers/MessagesContainer';
import RecallAnalysisContainer from '../../Containers/RecallAnalysisContainer';
import StatementsContainer from '../../Containers/StatementsContainer';
import PaymentsContainer from '../../Containers/PaymentsContainer';
import {useSelector} from 'react-redux';
import PatientAppointmentCardDetails from '../../../Patients/Patientdetails/PatientAppointmentCardDetails/PatientAppointmentCardDetails';
import CCMPatientsDrawerDetails from '../../../ChronicCareManagement/module-components/CCMPatientsDrawerDetails/CCMPatientsDrawerDetails';
import EligibilityVerificationContainer from '../../Containers/EligibilityVerificationContainer';
import PriorAuthPatientDrawerDetails from '../../../PriorAuthorization/PriorAuthPatientDrawer/PriorAuthPatientDrawerDetails';
import ClaimsTicketsPatientDetailsDrawer from '../../../ClaimsTickets/ClaimsTicketsPatientDetailsDrawer/ClaimsTicketsPatientDetailsDrawer';
import PharmacyClaimsPatientDetailsDrawer from '../../../Claims/PharmacyClaimsPatientDetailsDrawer/PharmacyClaimsPatinetDetailsDrawer';
import ReferralsTicketsPatientDetailsDrawer from '../../../ReferralsTickets/ReferralsTicketsPatientDetailsDrawer/ReferralsTicketsPatientDetailsDrawer';
import InsuranceHistoryContainer from '../../Containers/InsuranceContainer/InsuranceHistoryContainer';

const PatientTabToComponentMapper = [
  {
    key: PatientsTabKeys.PATIENT_DETAILS,
    component: DetailsContainer
  },
  {
    key: PatientsTabKeys.STATEMENTS,
    component: StatementsContainer
  },
  {
    key: PatientsTabKeys.PAYMENTS,
    component: PaymentsContainer
  },
  {
    key: PatientsTabKeys.MESSAGES,
    component: MessagesContainer
  },
  {
    key: PatientsTabKeys.APPOINTMENTS,
    component: PatientAppointmentCardDetails
  },
  {
    key: PatientsTabKeys.RECALL_ANALYSIS,
    component: RecallAnalysisContainer
  },
  {
    key: PatientsTabKeys.ELIGIBILITY_VERIFICATION,
    component: EligibilityVerificationContainer
  },
  {
    key: PatientsTabKeys.INSURANCE,
    component: InsuranceHistoryContainer
  },
  {
    key: PatientsTabKeys.CCM,
    component: CCMPatientsDrawerDetails
  },
  {
    key: PatientsTabKeys.PRIOR_AUTHORIZATION,
    component: PriorAuthPatientDrawerDetails
  },
  {
    key: PatientsTabKeys.CLAIMS_TICKETS,
    component: ClaimsTicketsPatientDetailsDrawer
  },
  {
    key: PatientsTabKeys.REFERRALS_TICKETS,
    component: ReferralsTicketsPatientDetailsDrawer
  },
  {
    key: PatientsTabKeys.PHARMACY_CLAIMS,
    component: PharmacyClaimsPatientDetailsDrawer
  }
];

const PatientDetailsContainer = (): JSX.Element => {
  // FIXME: ADD PROPER TYPES
  const activeTab = useSelector(
    (state: any) => state.patientDetailsDrawer?.activeTab
  );

  const activeItem = PatientTabToComponentMapper.find(
    item => item.key === activeTab
  );

  const ActiveContainer = activeItem?.component ?? DetailsContainer;

  return (
    <div className="patient-details-container-wrapper">
      <ActiveContainer />
    </div>
  );
};
export default PatientDetailsContainer;
